export const VEHICLE_INSTALLER_EVENT = [
    {
        eventID: 1,
        eventType: 'assigned installer',
        dateCreated: '2023-02-01T09:00:00Z',
        start: '2023-04-20T13:00:00Z',
        end: '2023-04-20T17:00:00Z',
        title: 'Installer A assigned to Vehicle 1',
        vehicleID: 8,
        installerID: 9
    },
    {
        eventID: 2,
        eventType: 'assigned installer',
        dateCreated: '2023-02-02T09:00:00Z',
        start: '2023-04-17T09:00:00Z',
        end: '2023-04-17T13:00:00Z',
        title: 'Installer B assigned to Vehicle 2',
        vehicleID: 9,
        installerID: 2
    },
    {
        eventID: 3,
        eventType: 'assigned installer',
        dateCreated: '2023-02-05T09:00:00Z',
        start: '2023-4-20T10:00:00Z',
        end: '2023-04-20T15:00:00Z',
        title: 'Installer C assigned to Vehicle 3',
        vehicleID: 21,
        installerID: 12
    },
    {
        eventID: 4,
        eventType: 'assigned installer',
        dateCreated: '2023-02-07T09:00:00Z',
        start: '2023-04-20T11:00:00Z',
        end: '2023-04-20T16:00:00Z',
        title: 'Installer D assigned to Vehicle 4',
        vehicleID: 24,
        installerID: 12
    },
    {
        eventID: 5,
        eventType: 'assigned installer',
        dateCreated: '2023-02-14T09:00:00Z',
        start: "2023-04-20T08:00:00Z",
        end: "2023-04-20T17:00:00Z",
        title: 'Installer E assigned to Vehicle 5',
        vehicleID: 7,
        installerID: 2
    }
];